// reducers/edgepositionedReducer.js
import { createSlice } from "@reduxjs/toolkit";
export const edgepositionedslice = createSlice({
  name: "edgepositioned",
  initialState: {
    edgepositioneds: [],
  },
  reducers: {

    Addedgepositioned: (state, action) => {
      //// console.log(action.payload)
      state.edgepositioneds = action.payload;
    },
    AddNewedgepositioned: (state, action) => {
      state.edgepositioneds = [action.payload, ...state.edgepositioneds];
    },
    updateedgepositioneds: (state, action) => {
      let data = action.payload;
      let index = state.edgepositioneds.findIndex((obj) => obj._id.toString() === data._id.toString())
      if (index !== -1) {
        state.edgepositioneds[index] = data;
      }
    },
    deleteedge: (state, action) => {
      const { edgepositionedId, commentId } = action.payload;
      let edgepositionedIndex = state.edgepositioneds.findIndex((edgepositioned) => edgepositioned._id.toString() === edgepositionedId.toString());
      if (edgepositionedIndex !== -1) {
        let comments = state.edgepositioneds[edgepositionedIndex].comments;
        const updatedComments = comments.filter((comment) => comment._id.toString() !== commentId.toString());
        state.edgepositioneds[edgepositionedIndex].comments = updatedComments;
      }
    },
    deleteedgepositioned: (state, action) => {
      let id = action.payload;
      const updatededgepositioneds = state.edgepositioneds.filter(function (edgepositioned) {
        return edgepositioned._id !== id;
      });
      state.edgepositioneds = updatededgepositioneds;
    },
    editComment: (state, action) => {
      const { edgepositionedId, commentId, text } = action.payload;
      let edgepositionedIndex = state.edgepositioneds.findIndex((edgepositioned) => edgepositioned._id.toString() === edgepositionedId.toString());
      if (edgepositionedIndex !== -1) {
        let commentIndex = state.edgepositioneds[edgepositionedIndex].comments.findIndex((comment) => comment._id.toString() === commentId.toString());
        if (commentIndex !== -1) {
          state.edgepositioneds[edgepositionedIndex].comments[commentIndex].text = text;
        }
      }
    },
    edgePositionLogout: (state) => {
          state.edgepositioneds = [];
        },
  

  },
});

export const selectedgepositioneds = (state) => state.edgepositioned.edgepositioneds;

export const { Addedgepositioned, updateedgepositioneds, deleteedge, AddNewedgepositioned, deleteComment, editComment, edgePositionLogout} = edgepositionedslice.actions; // actions
export default edgepositionedslice.reducer;
